import { clone } from "lodash";
import store from '@/store'

// Convert string to code
function convertToCode(str) {
  let code = '';
  code = str.replace(/\s/g, '').toUpperCase();
  return code;
}

// Convert size value to option data
export function sizeOptionData(value) {
  let size = value || "";
  let optionData = {};
  let boundary = size.split('x').map(e => e.match(/\d+/g)).filter(e => e).map(e => Number(e[0]));

  const orientation = store.state.selectedOrientation

  if (boundary.length == 2) {
    optionData['Width'] = orientation === 'portrait' ? boundary[0] : boundary[1]
    optionData['Height'] = orientation === 'portrait' ? boundary[1] : boundary[0]
  }

  return optionData;
}

// Convert bhsides value to option data
function bhsidesOptionData(value) {
  let optionData = {};
  if (value.toLowerCase() === 'double sided' || value.toLowerCase() === 'double-sided') {
    optionData['ImageUrl'] = "https://assets.fathead.com/_fh2012/land/custom/updates/Custom_Bighead_dbl_2.jpg"
  }
  else {
    optionData['ImageUrl'] = "https://assets.fathead.com/_fh2012/land/custom/updates/Custom_Bighead_dbl_1.jpg"
  }
  return optionData;
}

// Convert canvas edge value to option data
function canvasEdgeOptionData(value) {
  let optionData = {};

  switch (value) {
    case 'Black Edge':
      optionData['ImageUrl'] = 'https://cdn.shopify.com/s/files/1/0279/0234/5304/files/c_edge_black.png?v=1592527586'
      break;
    case 'White Edge':
      optionData['ImageUrl'] = 'https://cdn.shopify.com/s/files/1/0279/0234/5304/files/c_edge_white.png?v=1592527745'
      break;
    case 'Photo Wrap':
      optionData['ImageUrl'] = 'https://cdn.shopify.com/s/files/1/0279/0234/5304/files/c_edge_photo.png?v=1592528592'
      break;
    case 'Black Frame':
      optionData['ImageUrl'] = 'https://cdn.shopify.com/s/files/1/0279/0234/5304/files/c_frame_black.png?v=1592529870'
      break;
    case 'Black Wood Frame':
      optionData['ImageUrl'] = 'https://cdn.shopify.com/s/files/1/0279/0234/5304/files/c_frame_black.png?v=1592529870'
      break;
    case 'White Frame':
      optionData['ImageUrl'] = 'https://cdn.shopify.com/s/files/1/0279/0234/5304/files/white_frame_smpl.jpg?v=1592724555'
      break;
    case 'Gold Frame':
      optionData['ImageUrl'] = 'https://cdn.shopify.com/s/files/1/0279/0234/5304/files/gold_frame_smpl.jpg?v=1592529982'
      break;
    case 'Silver Frame':
      optionData['ImageUrl'] = 'https://cdn.shopify.com/s/files/1/0279/0234/5304/files/silver_frame_smpl.jpg?v=1592529982'
      break;
    case 'Wood Frame':
      optionData['ImageUrl'] = 'https://cdn.shopify.com/s/files/1/0279/0234/5304/files/wood_frame_smpl.jpg?v=1592529982'
      break;
    default:
      optionData = {}
  }
  return optionData;
}

// Convert bhsides value to price
function getBHSidesPrice(value) {
  if (value.toLowerCase() === 'double sided' || value.toLowerCase() === 'double-sided') return 10;
  return 0;
}

// Return option price
function getOptionPrice(option, optGrp) {
  if (option.price) return option.price;
  if (!!optGrp.isDesignOption && option.optionCode === "RETOUCH") return 25;
  return 0;
}

// Return option list price
function getOptionListPrice(option, optGrp) {
  if (option.listPrice) return option.listPrice;
  if (!!optGrp.isDesignOption && option.optionCode === "RETOUCH") return 25;
  return 0;
}

// Return minimum price of the same kind of variants
function getMinVariant(variants, size=null) {
  let variant = null;
  let sameVariants = clone(variants);
  if (size) {
    sameVariants = variants.filter(e => e.size === size);
  }
  sameVariants.sort((a,b) => (a.price > b.price) ? 1 : ((b.price > a.price) ? -1 : 0));
  return sameVariants[0];
}

// Return size option group from materialSizes and selected material index
export const initSizeOptionGroup = (materialSizes = [], i = 0) => {
  let sizeOptions = []
  let variants = materialSizes[i].variants
  variants.forEach((variant) => {
    let index = sizeOptions.findIndex(e => e.name === variant.size)
    if (index == -1) {
      var min_variant = getMinVariant(variants, variant.size);
      sizeOptions.push({
        groupName: 'Size',
        groupCode: 'SIZE',
        name: variant.size,
        optionCode: variant.size,
        optionData: sizeOptionData(variant.size),
        isSize: true,
        minPPI: 100,
        isStoreOption: true,
        price: Number(min_variant.price),
        listPrice: Number(min_variant.listPrice)
      })
    }
  })

  let sizeOptionGroup = {
    name: 'Size',
    code: 'SIZE',
    isSize: true,
    options: sizeOptions
  }

  return sizeOptionGroup
}

// Return bhsides option group from materialSizes and selected material index
export const initBHSidesOptionGroup = (materialSizes = [], i = 0) => {
  let bhsidesOptions = []
  materialSizes[i].variants.forEach((variant) => {
    if (variant.bhsides) {
      let index = bhsidesOptions.findIndex(e => e.name === variant.bhsides)
      if (index == -1) {
        bhsidesOptions.push({
          groupName: 'Big Head Sides',
          groupCode: 'BHSIDES',
          name: variant.bhsides,
          optionCode: convertToCode(variant.bhsides),
          optionData: bhsidesOptionData(variant.bhsides),
          isStoreOption: true,
          listPrice: getBHSidesPrice(variant.bhsides),
          price: getBHSidesPrice(variant.bhsides)
        })
      }
    }
  })

  let bhsidesOptionGroup = {
    name: 'Big Head Sides',
    code: 'BHSIDES',
    description: "Our standard Big Heads are printed on one side with the Fathead logo on the other side. You have the option of creating a 2-sided Big Head. The printing on the reverse side will be the mirror image of your photo.",
    options: bhsidesOptions
  }

  return bhsidesOptionGroup
}

// Return canvasedge option group from materialSizes and selected material index
export const initCanvasEdgeOptionGroup = (materialSizes = [], i = 0) => {
  let canvasEdgeOptions = []
  materialSizes[i].variants.forEach((variant) => {
    if (variant.canvasedge) {
      let index = canvasEdgeOptions.findIndex(e => e.name === variant.canvasedge)
      if (index == -1) {
        canvasEdgeOptions.push({
          groupName: 'Edge/Frame Option',
          groupCode: 'CANVASEDGE',
          name: variant.canvasedge,
          optionCode: convertToCode(variant.canvasedge),
          optionData: canvasEdgeOptionData(variant.canvasedge),
          isStoreOption: true,
          listPrice: 0,
          price: 0
        })
      }
    }
  })

  let canvasEdgeOptionGroup = {
    name: 'Edge/Frame Option',
    code: 'CANVASEDGE',
    options: canvasEdgeOptions
  }

  return canvasEdgeOptionGroup
}

// Generate option groups from materialSizes
export const initialOptionGroupsFromMaterial = (materialSizes = [], i = 0) => {
  let convertedOptionGroups = []
  if (materialSizes.length > 0) {
    let materialOptionGroup = {
      name: 'Material',
      code: 'MATERIAL',
      isMaterial: true,
      options: materialSizes.map((e) => ({
        groupName: 'Material',
        groupCode: 'MATERIAL',
        name: e.name,
        isStoreOption: true,
        optionCode: e.code,
        optionData: {},
        isMaterial: true
      }))
    }

    let sizeOptionGroup = initSizeOptionGroup(materialSizes, i)
    let bhsidesOptionGroup = initBHSidesOptionGroup(materialSizes, i)
    let canvasEdgeOptionGroup = initCanvasEdgeOptionGroup(materialSizes, i)

    convertedOptionGroups.push(materialOptionGroup)
    convertedOptionGroups.push(sizeOptionGroup)
    if (bhsidesOptionGroup.options.length > 0) {
      convertedOptionGroups.push(bhsidesOptionGroup)
    }
    if (canvasEdgeOptionGroup.options.length > 0) {
      convertedOptionGroups.push(canvasEdgeOptionGroup)
    }
  }
  return convertedOptionGroups
}

// Remove single option groups and re-ranking
export const initialOptionGroups = (optionGroups = [], baseSort = 0) => {
  let optGrps = optionGroups
    .filter(e => e.code === 'DESIGNOPTIONS' || e.options.length > 1);

  let result = [];
  optGrps.forEach((optGrp, index) => {
    let optionGroup = {
      ...optGrp,
      isFilter: optGrp.code == 'FILTER',
      sort: baseSort + index + 1,
      options: optGrp.options.map((opt) => (
        {
          ...opt,
          price: getOptionPrice(opt, optGrp),
          listPrice: getOptionListPrice(opt, optGrp),
          isFilter: optGrp.code == 'FILTER',
          isDesignOption: !!optGrp.isDesignOption,
          groupName: optGrp.code == 'DESIGNOPTIONS' ? opt.name : optGrp.name,
          groupCode: optGrp.code == 'DESIGNOPTIONS' ? opt.optionCode : optGrp.code
        }
      ))
    }

    if (!!optionGroup.isFilter) {
      optionGroup.options.unshift({
        optionCode: "none",
        name: "None",
        groupName: optionGroup.name,
        groupCode: optionGroup.code,
        optionData: {
          ImageUrl:
            "https://rfathead-res.cloudinary.com/image/upload/v1541807002/customizer/none-option.png",
          FilterParameter: null,
        },
        isFilter: true
      })
    }

    result.push(optionGroup)
  });

  return result;
}

// Get variant id
export const getVariant = (materialSizes = [], allSelectedOptions = {}) => {
  let _variant = null
  let allOptions = Object.values(allSelectedOptions)
  let selectedOptions = allOptions.filter(e => e.selected && e.isStoreOption && !e.isMaterial)
  let selectedVariants = []

  if (allSelectedOptions.MATERIAL && allSelectedOptions.MATERIAL.selected) {
    let filteredMaterial = materialSizes.find(e => e.name === allSelectedOptions.MATERIAL.name)
    if (filteredMaterial) { selectedVariants = filteredMaterial.variants }
  }

  if (selectedOptions.length > 0 && selectedVariants.length > 0) {
    let variants = JSON.parse(JSON.stringify(selectedVariants))
    for (let option of selectedOptions) {
      if (option.groupCode === 'SIZE') {
        variants = variants.filter(e => option.name === e.size)
      }
      if (option.groupCode === 'BHSIDES') {
        variants = variants.filter(e => option.name === e.bhsides)
      }
      if (option.groupCode === 'CANVASEDGE') {
        variants = variants.filter(e => option.name === e.canvasedge)
      }
    }

    if (variants.length > 0) { _variant = variants[0] }
  }

  return _variant;
}


// Get material from tags
export const getMaterial = (tags = []) => {
  let material = null
  const materialTag = tags.find(e => e.includes('material:'))
  if (materialTag) {
    material = materialTag.split(/:/)[1]
  }

  return material
}

// Filter optionGroups by material
export const getFilteredOrderGroups = (optionGroups, material) => {
  return optionGroups.filter(optGrp => {
    if (material.toLowerCase() == 'acrylic' && optGrp.code.toLowerCase() == 'sobase') {
      return false
    }

    return true
  })
}

export const updateCanvasPrices = (canvasOptionGroup, variants) => {
  let optionGroup = {...canvasOptionGroup};
  let minVariant = getMinVariant(variants), variant;
  for (var i = 0; i < optionGroup.options.length; i++) {
    variant = variants.find(e => e.canvasedge === optionGroup.options[i].name)
    if (variant) {
      optionGroup.options[i].price = parseInt(parseFloat(variant.price) - parseFloat(minVariant.price));
    }
  }
  return optionGroup;
}
